import { types, actions } from './requests'
export const CREATEORGANIZATION_TYPES = {
    ...types('CREATEORGANIZATION'),
}
export const CREATEORGANIZATION_ACTIONS = {
    ...actions('CREATEORGANIZATION'),
}
